import React, { useContext } from "react";
import { DataAssuranceContext } from "../types";
import { InputElement } from "../../../HtmlComponents/InputElement";
import { useTranslation } from "react-i18next";
import { InputImage } from "../../../HtmlComponents/InputImage";
import { hostName } from "../../../requestMethods";

const InputsAssurance: React.FC = () => {
  const {
    name, setName,
    description, setDescription,
    image, setImage,
  } = useContext(DataAssuranceContext);
  const { t } = useTranslation()

  return (
    <div>
      <InputElement
        type="text"
        name={t("Nom")}
        placeholder="Nom de la societe"
        id="Name"
        value={name}
        setValue={setName}
      />
      <InputElement
        name={t("Description")}
        id="desc"
        value={description}
        setValue={setDescription}
      />
      <InputImage name="Photo" setValue={setImage}/>
      {(image && (typeof image === 'string')) && <img className='w-full h-56 col-span-2' src={hostName + "imgs/assurances/" + image} alt="imageAss" /> }          
      {(image && (typeof image !== 'string')) && <img className='w-full h-56 col-span-2' src={URL.createObjectURL(image)} alt="imageAss" /> }          
    </div>
  );
};

export default InputsAssurance;
